module.exports = __webpack_public_path__ + "icon.5fe89720e74e8eed5300.svg";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/icon.svg
// module id = ../../../../../www/assets/fonts/icon.svg
// module chunks = styles